import {Data, Int} from '@store/@types/util';

export type TagId = Int;
interface TagInfoInterface {
  id: TagId;
  name: string;
}

/**
 * Trigger Rule Tag
 * @link TriggerRuleInfo
 */
export class TagInfo extends Data<TagInfoInterface>({
  id: undefined,
  name: undefined,
}) {}
